import React from 'react';
import{ isEmpty, get } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsStepFlow as WidgetsStepFlowView } from 'modules/widgetsStepFlow';
import { widgetsStepFlowPreloader as WidgetsStepFlowPreloader } from 'modules/widgetsStepFlow';
import { pageLevelSuccessAcknowledgement as PageLevelSuccessAcknowledgement } from 'ui/views/widgets/pageLevelSuccessAcknowledgement';

// success view
export const reactivateEpostSuccess = ( props ) => {

    if( isEmpty( get( props, 'successView', {} ) ) ) {

        return (
            <div className='ui-reactivate-epost'>
                <WidgetsStepFlowView
                    activeStepIndex={ props.currentStep - 1 }
                    steps={ props.steps }
                    requestPayload={ props.requestPayload }
                />
            </div>
        );
    } else {

        return (
            <div className='ui-checkout'>
                <PageLevelSuccessAcknowledgement
                    { ...props.successView  }
                    onActionClick = { props.onSuccessfullEnrollment }
                    type={ 'default' } />
            </div>
        );
    }
};

// set display name
reactivateEpostSuccess.displayName = 'reactivateEpostSuccess';

// set default props
reactivateEpostSuccess.defaultProps = {
    currentStep: 1,
    requestPayload: {},
};

// prop types
reactivateEpostSuccess.propTypes = {};

/*******************************/

// preloader view
export const reactivateEpostPreloader = () => {
    return (
        <div className='ui-reactivate-epost-preloader'>
             <WidgetsStepFlowPreloader />
        </div>
    );
};

// set display name
reactivateEpostPreloader.displayName = 'reactivateEpostPreloader';

// set default props
reactivateEpostPreloader.defaultProps = {};

// prop types
reactivateEpostPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { reactivateEpost as ReactivateEpost } from 'ui/views/widgets/reactivateEpost';
 *
 * // render
 * <ReactivateEpost propName='propValue'/>
 */
export const reactivateEpost = withNetworkState( reactivateEpostPreloader, reactivateEpostSuccess );
